export const FEATURE_FLAGS: Record<string, string[]> = {
  'bayerische-staatsoper': ['new_image_banner_feature'],
};

export function getFeatureFlagsHeaderValue(
  tenantId: string,
): string | undefined {
  const flags = FEATURE_FLAGS[tenantId];
  if (!flags || flags.length === 0) return undefined;
  return flags.join(',');
}

export const FEATURE_FLAGS_SUPERTOKENS: Record<string, string[]> = {
  'bayerische-staatsoper': ['B2B_ADMIN_FEATURE'],
  'julia-fischer': ['B2B_ADMIN_FEATURE'],
  'perce-neige': ['B2B_ADMIN_FEATURE'],
  pitiesalpetriere: ['B2B_ADMIN_FEATURE'],
  'zurich-operahaus': ['B2B_ADMIN_FEATURE'],
};

export function getFeatureFlagsHeaderSupertokensValue(
  tenantId: string,
): string | undefined {
  const flags = FEATURE_FLAGS_SUPERTOKENS[tenantId];
  if (!flags || flags.length === 0) return undefined;
  return flags.join(',');
}
